import * as React from 'react';
import { DEFAULT_FLAGS_BY_TIER, type FeatureFlags, type LicenseTier } from '@tokenforge/shared';

interface ContextValue {
  licenseTier: LicenseTier;
  flags: FeatureFlags;
}
const FeatureFlagContext = React.createContext<ContextValue | null>(null);

export interface FeatureFlagProviderProps {
  licenseTier: LicenseTier;
  overrides?: Partial<FeatureFlags>;
  children: React.ReactNode;
}

export function FeatureFlagProvider({
  licenseTier,
  overrides,
  children,
}: FeatureFlagProviderProps) {
  const flags = React.useMemo<FeatureFlags>(
    () => ({ ...DEFAULT_FLAGS_BY_TIER[licenseTier], ...overrides }),
    [licenseTier, overrides],
  );
  return (
    <FeatureFlagContext.Provider value={{ licenseTier, flags }}>
      {children}
    </FeatureFlagContext.Provider>
  );
}

export function useFeatureFlagContext() {
  const ctx = React.useContext(FeatureFlagContext);
  if (!ctx) throw new Error('useFeatureFlag must be used inside FeatureFlagProvider');
  return ctx;
}
